import state from "./moduleDepotState.js";
import mutations from "./moduleDepotMutations.js";
import actions from "./moduleDepotActions.js";
import getters from "./moduleDepotGetters.js";

export default {
	isRegistered: false,
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
